export function readCookie(name: string): string | null {
  const prefix = `${name}=`;

  for (const entry of document.cookie.split(';')) {
    const cookie = entry.trim();

    if (!cookie.startsWith(prefix)) {
      continue;
    }

    const value = cookie.slice(prefix.length);

    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }

  return null;
}
